import { NgModule } from '@angular/core';

import { SharedModule } from '@shared';

import { TaskFeasibilityInfoModule } from 'planner-shared';

import { DataUpdateComponent } from './data-update.component';
import { PatientsComponent } from './patients/patients.component';
import { PatientInfoComponent } from './patient-info/patient-info.component';
import { PatientAddressComponent } from './patient-address/patient-address.component';
import { PatientTasksComponent } from './patient-tasks/patient-tasks.component';
import { PatientTaskEditComponent } from './patient-tasks/edit/patient-task-edit.component';
import { PatientsOverviewComponent } from './patients-overview/patients-overview.component';
import { PatientsTimeWindowSuggestionsComponent } from './patients-time-window-suggestions/patients-time-window-suggestions.component';
import { PatientMainResponsiblesComponent } from './patient-main-responsibles/patient-main-responsibles.component';
import { FormInputAutocompleteModule } from '../../../_shared/form-input-autocomplete/form-input-autocomplete.module';

@NgModule({
    declarations: [
        DataUpdateComponent,
        PatientsComponent,
        PatientInfoComponent,
        PatientAddressComponent,
        PatientTasksComponent,
        PatientTaskEditComponent,
        PatientsOverviewComponent,
        PatientsTimeWindowSuggestionsComponent,
        PatientMainResponsiblesComponent
    ],
    imports: [SharedModule, TaskFeasibilityInfoModule, FormInputAutocompleteModule]
})
export class DataUpdateModule {}
